import { render, staticRenderFns } from "./WidgetIcon.vue?vue&type=template&id=daec9d18&scoped=true&"
import script from "./WidgetIcon.vue?vue&type=script&lang=ts&"
export * from "./WidgetIcon.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetIcon.vue?vue&type=style&index=0&id=daec9d18&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daec9d18",
  null
  
)

export default component.exports